import { BaseLayoutFactory } from "../global/base-layout-factory";
import { CityInfoComponent } from "./city-info-component";

export function CityInfoFactory() {
    return (
        <BaseLayoutFactory>
            <CityInfoComponent />
        </BaseLayoutFactory>
    );
}
